import { gql } from '@apollo/client'

export interface IEnabledFeaturesData {
  enabledFeatures: { name: string }[] | null
}

export const ENABLED_FEATURES = gql`
  query EnabledFeatures {
    enabledFeatures {
      name
    }
  }
`
